// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"14cc29c7","455":"af4a2b4d","488":"d22bcd9e","977":"1432c79c"}[chunkId] + ".chunk.js";
};